<template>
  <div>
    <b-card class="p-2 mt-10 border-b4b4b4">
      <div class="flex items-center">
        <!-- <img src="@/assets/images/7.png" alt="img" class="img-100px" /> -->
        <div class="media-body align-self-center">
          <h5 class="font-bold text-xl text-black">
            {{
              selectedCourseHome.author
                .map((data) => {
                  if (data.userId) {
                    return data.userId.firstname + " " + data.userId.lastname;
                  }
                })
                .toString()
            }}
          </h5>
          <p class="fsize16 font-normal">
            {{
              selectedCourseHome.author
                .map((data) => data.designation)
                .toString()
            }}
          </p>
          <!-- <div class="rating-inner">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
          </div> -->
        </div>
      </div>
      <p
        class="fsize16 sm-fsize16 mt-4 font-medium"
        v-html="
          selectedCourseHome.author.map((data) => data.aboutMe).toString()
        "
      ></p>
    </b-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("eLearning", ["selectedCourseHome"]),
  },
};
</script>
